import React, { useEffect, useState } from 'react';
import { Card, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { API_URL } from '../const';
import { formatFullInr, formatShortInr } from '../utils/formatAmount';

export default function PendingOrderValue() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  const token = sessionStorage.getItem('quotetoken')?.replace(/^"|"$/g, '');
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setData(null);
    setError(false);
    axios.get(API_URL + 'po-sales/pending-summary', {
      headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
      signal: controller.signal,
    }).then(response => {
      const result = response.data?.data;
      if (!response.data?.status || !Number.isFinite(result?.amount) || !Number.isSafeInteger(result?.orders) || result.orders < 0) throw new Error('Invalid summary');
      if (active) setData(result);
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; controller.abort(); };
  }, [token, retry]);
  return (
    <Card className="dashboard-stat-card dashboard-stat-card--amount h-100">
      <Card.Body>
        <div className="dashboard-stat-icon"><FontAwesomeIcon icon={faRupeeSign} /></div>
        <p className="dashboard-stat-label">Pending Order Value</p>
        {error ? <div role="alert">Unable to load pending order value. <Button size="sm" variant="outline-primary" onClick={() => setRetry(value => value + 1)}>Retry</Button></div>
          : data ? <>
            <h3 className="dashboard-stat-value" title={formatFullInr(data.amount)}>{formatShortInr(data.amount)}</h3>
            <p className="dashboard-stat-meta mb-0">{data.orders.toLocaleString('en-IN')} pending orders · All received dates</p>
          </> : <p role="status">Loading pending order value...</p>}
      </Card.Body>
    </Card>
  );
}
